import { Text } from "@netapp/bxp-design-system-react";
import { CloseMonochromeIconsIcon as CloseIcon } from "@netapp/bxp-design-system-react/icons/monochrome";
import { ClockIcon } from "@netapp/bxp-style/react-icons/General";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import { globalSearch as i18nNamespace} from "../../../i18n/namespace";
import { narrowedObjectTypes, useObjectTypeFilter } from "./objectTypeFilter";
import styles from "../GlobalSearch.module.scss";

const recentSearchText = item => typeof item === "string" ? item : item?.text;

const RecentResults = ({ recentSearches, focusGlobalSearch }) => {
    const { t } = useTranslation(i18nNamespace);
    const dispatch = useDispatch();
    const filterContext = useObjectTypeFilter();

    return <div className={styles['recent-results']}>
        <Text className={styles['recent-title']}>{t('recent_searches')}</Text>
        {recentSearches.map(item => {
            const text = recentSearchText(item);
            if (!text) {
                return null;
            }

            return <div className={styles['recent-item']} key={text}>
                <button
                    type="button"
                    className={styles['recent-item-button']}
                    onMouseDown={event => event.preventDefault()}
                    onClick={() => {
                        dispatch({
                            type: "GLOBAL-SEARCH/SET-INPUT",
                            payload: text
                        });
                        const objectTypes = narrowedObjectTypes(filterContext?.objectTypeFilter);
                        dispatch({
                            type: "GLOBAL-SEARCH/SEARCH",
                            payload: {
                                searchTerm: text,
                                ...(objectTypes ? { objectTypes } : {})
                            },
                            track: text
                        });
                    }}
                >
                    <ClockIcon />
                    <span>{text}</span>
                </button>
                <button
                    type="button"
                    className={styles['recent-remove']}
                    aria-label={t('remove_recent_search', { name: text })}
                    onMouseDown={event => {
                        event.preventDefault();
                        event.stopPropagation();
                    }}
                    onClick={event => {
                        event.preventDefault();
                        event.stopPropagation();
                        dispatch({
                            type: "GLOBAL-SEARCH/REMOVE-RECENT-SEARCH",
                            payload: text
                        });
                        focusGlobalSearch?.();
                    }}
                >
                    <CloseIcon />
                </button>
            </div>;
        })}
    </div>
}

export default RecentResults;
